import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';

import * as _moment from 'moment';
import {Moment} from 'moment';
import {simpleValueAccessorProvider, SimpleValueAccessorSupportComponent} from '../../../util/angular/simple-value-accessor'

const moment =  _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export interface YearMonth {
  year: string,
  month: string,
}

@Component({
  selector: 'shared-datepicker-yearmonth',
  templateUrl: 'datepicker-yearmonth.component.html',
  styleUrls: ['datepicker-yearmonth.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    simpleValueAccessorProvider(DatepickerYearmonthComponent)
  ],
  encapsulation: ViewEncapsulation.None
})
export class DatepickerYearmonthComponent extends SimpleValueAccessorSupportComponent<YearMonth> implements OnInit {

  @Input()
  minDate!: Date;

  @Input()
  maxDate!: Date;

  date = new UntypedFormControl(moment());

  ngOnInit(): void {
    this.synchronizeModel()
  }

  chosenYearHandler(normalizedYear: Moment): void {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
    this.synchronizeModel()
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>): void {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.synchronizeModel()
  }

  registerOnChange(fn: any): void {
    super.registerOnChange(fn);
    this.synchronizeModel();
  }

  writeValue(value: YearMonth): void {
    const ctrlValue = this.date.value;
    ctrlValue.year(value?.year);
    ctrlValue.month(+value?.month - 1);
    this.date.setValue(ctrlValue);
  }

  private synchronizeModel(): void {
    this.value = this.prepareDate();
    this.valueChanged();
  }

  private prepareDate(): YearMonth {
    const year: string = this.date.value.year().toString();
    const month: string = this.formatMonth((this.date.value.month() + 1).toString())
    return { year, month }
  }

  private formatMonth(month: string): string {
    return ([...month].length < 2 ? `0${month}` : month).toString()
  }
}
